export const tr = {
  // Landing
  fieldGuide: '§ AR Rehberi',
  title: 'Artırılmış Gerçeklik Deneyimi:',
  titleHighlight: 'Porta Giuliana',
  landingDescription: "Porta Giuliana'nın tarihine bir Artırılmış Gerçeklik deneyimiyle adım atın. Anıtı telefonunuzla keşfedin, hikayelerini öğrenin ve geçmişin 3D modeller ve dijital rekonstrüksiyonlarla yeniden canlandığını görün. Yolculuğa hazır mısınız?",
  plateCaption: "Levha I. — Doğu cephesi, Caoursin'den sonra.",
  hotspots: '§ 12 nokta',
  duration: '~ 25 dakika',
  beginWalk: 'Deneyimi Başlat',

  // Story
  theGate: '§ 01 · Kapı',
  portaGiuliana: 'Porta',
  giuliana: 'Giuliana',
  gateSubtitle: "Lefkoşa'nın Venedik surlarının doğu kapısı",
  storyP1: "1567'de, Osmanlı İmparatorluğu bakışlarını Akdeniz üzerinden batıya çevirirken, Venedik Cumhuriyeti Lefkoşa'nın ortaçağ tahkimatlarının tamamen yeniden inşasını emretti. Askeri mühendis Giulio Savorgnan, on bir burçlu bir sur planı çizdi — top ateşini absorbe etmek ve saldırganları ölüm bölgelerine yönlendirmek için tasarlanmış açılı duvarlardan oluşan bir halka.",
  storyP2: "Yeni surları üç kapı deliyordu: batıda Baf, kuzeyde Girne ve bu — Porta Giuliana, Mağusa Kapısı — doğuda, adanın ana limanına giden yola bakan.",

  // AR Prompt
  arExperience: '§ AR Deneyimi',
  readyTo: 'Keşfetmeye',
  explore: 'hazır mısınız?',
  arDescription: 'Gizli hikayelerini keşfetmek için kameranızı kapıya doğrultun. Tarihsel detayların kilidini açmak için köşeli işaretleri arayın.',
  enableCamera: 'Kamerayı etkinleştir',
  beforeYouBegin: 'Başlamadan önce',
  tipVolume: 'Seslendirmeyi net duyabilmek için telefonunuzun sesini açın.',
  tipCamera: 'Kamera ve hareket sensörü erişimine izin verin. AR deneyimi için gereklidir.',
  requestingAccess: 'Erişim isteniyor...',
  redirectingToExperience: 'Deneyime giriliyor...',
  cameraReady: 'Kamera hazır',
  cameraReadyDesc: 'AR deneyimi başlamaya hazır.',
  startExploring: 'Keşfetmeye başla',
  cameraDenied: 'İzin reddedildi',
  cameraDeniedDesc: 'Lütfen tarayıcı veya cihaz ayarlarınızda kamera ve hareket erişimini etkinleştirin, ardından buraya geri dönün.',
  tryAgain: 'Etkinleştirdim',

  // Time restriction
  afterHours: 'Kapı dinleniyor',
  afterHoursDesc: 'Bu deneyim sabah 7 ile akşam 7 arasında, gün ışığının taş işçiliğini aydınlattığı ve gölgelerin yüzyılların duvarlara aşındırdığı detayları ortaya çıkardığı saatlerde kullanılabilir. Güneş yükseldiğinde geri dönün.',

  // Desktop
  desktopNotice: '§ SAHADA MOBİL DENEYİM',
  aboutTitle: 'Hakkında',
  termsTitle: 'Koşullar',
  creditsTitle: 'Katkıda Bulunanlar',
  pageTitle: 'Mağusa Kapısı',
  desktopTitle: "Porta Giuliana'da Artırılmış Gerçeklik Deneyimi",
  desktopDescription: "AREXPG, Lefkoşa'nın Venedik surlarının en doğusundaki kapısı olan Porta Giuliana için bir mobil artırılmış gerçeklik saha rehberidir. \n Deneyim, ziyaretçi kapıda fiziksel olarak bulunurken telefonun kamerasını, pusulasını, yönelimini ve konumunu kullanır. Bu nedenle masaüstü bilgisayardan erişilemez.",
  desktopNote: "Başlamak için Porta Giuliana'dayken bu sayfayı mobil cihazda açın. Deneyim şafak ile gün batımı arasında kullanılabilir.",
  scanWithPhone: 'Telefonunuzla tarayın',
  plateI: 'Levha I. — Mağusa Kapısı, doğu cephesi.',
  mobileOnly: 'Sadece mobil',

  // Menu
  language: 'Dil',

  // Footer
  about: 'Hakkında',
  terms: 'Koşullar',
  credits: 'Katkıda Bulunanlar',
  back: 'Geri',

  // Image and control labels

  // Markdown pages
  loading: 'Yükleniyor...',
  error: 'Hata',
  loadFailed: 'İçerik yüklenemedi.',

  // Cookie banner
  cookieTitle: 'Çerezler',
  cookieText:
    'Deneyimin nasıl kullanıldığını anlamak ve geliştirmek için Google Analytics çerezleri kullanıyoruz. Yalnızca kabul ederseniz etkinleştirilirler.',
  cookieAccept: 'Kabul et',
  cookieDecline: 'Reddet',
  cookieSettings: 'Çerez ayarları',
};
